// Configuration exports

export { theme, designTokens } from './theme';

const STORAGE_KEY = 'client_type';
const DEFAULT_CLIENT = 'default';

/**
 * Resolve the client type from URL query params, localStorage, or fallback to default.
 * If found in query params, saves to localStorage for future visits.
 */
function resolveClientType() {
  const params = new URLSearchParams(window.location.search);
  const paramValue = params.get('client_type');

  if (paramValue) {
    localStorage.setItem(STORAGE_KEY, paramValue);
    return paramValue;
  }

  const storedValue = localStorage.getItem(STORAGE_KEY);
  if (storedValue) {
    return storedValue;
  }

  return DEFAULT_CLIENT;
}

/**
 * Build a client config object with data file paths based on client type.
 */
function buildClientConfig(clientType) {
  const basePath = `/data/clients/${clientType}`;

  return {
    id: clientType,
    basePath,
    data: {
      geojson: `${basePath}/od_map.json`,
      percentages: `${basePath}/data_percentages.json`,
      config: `${basePath}/config.json`,
    },
  };
}

// Active client configuration - resolved dynamically
export const activeClient = buildClientConfig(resolveClientType());
